import { render, staticRenderFns } from "./Row2.vue?vue&type=template&id=4a50626c&scoped=true"
import script from "./Row2.vue?vue&type=script&lang=js"
export * from "./Row2.vue?vue&type=script&lang=js"
import style0 from "./Row2.vue?vue&type=style&index=0&id=4a50626c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50626c",
  null
  
)

export default component.exports